import Vue from 'vue'
import {CONFIG} from './config.js';

const ForgottenPasswordForm = Vue.component('forgotten_password_form', {
    data: function() {
        return {
            email: null,
            emailChanged: false
        }
    },
    watch: {
        email: function(v) {
            this.emailChanged = (v !== null);
        }
    },
    computed: {
        emailRegex: function() {
            return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        },
        invalidEmailFeedback: function() {
            if (!this.emailChanged) {
                return '';
            }

            if (!this.email) {
                return this.$t('resetPassword.noEmailError');
            } else if (!this.emailRegex.test(this.email)) {
                return this.$t('resetPassword.invalidEmailError');
            }

            return '';
        },
        isEmailValid: function() {
            if (!this.emailChanged) {
                return null;
            }

            return this.invalidEmailFeedback == '';
        },
        isValid: function() {
            return this.isEmailValid
        }
    },
    methods: {
        send: function() {
            var self = this;

            this.$request("post", CONFIG.api.endpoints.forgottenPassword,
                function() {
                    self.$store.dispatch('eraseLoggedUserSession')
                    self.$ebus.$emit("msg:new", {type: "success-modal",
                        data: {
                            text: self.$t("resetPassword.requestSent"),
                            onclick: () => self.$router.push("/login")
                        }})

                },
                {
                    data:
                    {
                        "login_": this.email
                    },
                    headers: {
                        'Authorization': "Bearer " + CONFIG.resetPasswordToken
                    }
                }
            )
        }
    },
    filters: {
        uppercase: function(v) {
            return v.toUpperCase();
        }
    },

    template: '#forgotten_password_form'
})

export default ForgottenPasswordForm;